import React from 'react';
import { useAuth } from '../context/contextAPI';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/auth/connexion" />;
  }

  return element;
};

export default ProtectedRoute;